module.exports = __webpack_public_path__ + "media/images/emblems/Ursy-coat_of_arms-333dfe40608b3f36c384e5059a79610c.svg";